module.exports = __webpack_public_path__ + "img/图片21.3d7563a4.png";